import './EventBooking.css'
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";
import { useSelectedItem } from "../context/store";
import Loginpopup from "../Navbar/Loginmodal";
import iziToast from 'izitoast';
import { FaLocationDot } from "react-icons/fa6";
import { SlCalender } from "react-icons/sl";
import 'izitoast/dist/css/iziToast.min.css';
import { FaDirections } from "react-icons/fa";

export default function EventBooking() {
    const { selectedItem, handleItemClick } = useSelectedItem();
    const params = useParams();

    // State management
    const [eventdetailsTicket, setEventdetailsTicket] = useState([]);
    const [eventdetails1, setEventdetails1] = useState({});
    const [responseMessage, setResponseMessage] = useState("");
    const [showResponse, setShowResponse] = useState(false);
    const [ticketCounts, setTicketCounts] = useState({});
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [responseId, setResponseId] = useState("");
    const [loading, setLoading] = useState(false);
    const [useCarrotBalance, setUseCarrotBalance] = useState(true);

    // Constants
    const url = "https://partywitty.com/master/assets/uploads/";
    const platformFee = 5.00;
    const freePlatformFee = 50.00;
    const gstPercentage = 18;
    const carrotDiscount = 50.00;
    const maxFreeTickets = 10;

    // User data
    const userdata = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem("userData"));
        } catch {
            return null;
        }
    }, []);

    // Utility function to format Indian currency
    const formatIndianCurrency = useCallback((amount) => {
        if (amount === 0) return "₹0";

        const numStr = Math.round(amount).toString();
        const lastThree = numStr.substring(numStr.length - 3);
        const otherNumbers = numStr.substring(0, numStr.length - 3);

        if (otherNumbers !== '') {
            return `₹${otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",")}${lastThree}`;
        } else {
            return `₹${lastThree}`;
        }
    }, []);

    // Check if tickets are free
    const isFreeTiket = useMemo(() => {
        return eventdetailsTicket.length > 0 && eventdetailsTicket[0]?.ticket_type === "Free";
    }, [eventdetailsTicket]);

    // Calculate totals
    const calculations = useMemo(() => {
        const ticketTotal = eventdetailsTicket.reduce((total, ticket) => {
            const count = ticketCounts[ticket.id] || 0;
            return total + (parseFloat(ticket.price) || 0) * count;
        }, 0);

        const totalQty = Object.values(ticketCounts).reduce((sum, count) => sum + count, 0);


        // For free tickets, fixed pricing: 50 rs + 18% GST = 59 rs for up to 10 tickets
        if (isFreeTiket) {
            const gstAmount = (freePlatformFee * gstPercentage) / 100;
            const finalAmount = freePlatformFee + gstAmount;

            return {
                ticketTotal: 0, // Free tickets have no base cost
                totalQty,
                platformFee: freePlatformFee,
                gstAmount,
                carrotDiscount: 0, // No carrot discount for free tickets
                finalAmount,
                maxTicketsReached: totalQty >= maxFreeTickets
            };
        }

        // For paid tickets - only actual ticket amount, no GST or platform fee
        const carrotDiscountAmount = useCarrotBalance ? carrotDiscount : 0;
        const finalAmount = Math.max(0, ticketTotal - carrotDiscountAmount);

        return {
            ticketTotal,
            totalQty,
            platformFee: 0, // No platform fee for paid tickets
            gstAmount: 0, // No GST for paid tickets
            carrotDiscount: carrotDiscountAmount,
            finalAmount,
            maxTicketsReached: false
        };
    }, [eventdetailsTicket, ticketCounts, isFreeTiket, useCarrotBalance]);

    // Script loader
    const loadScripts = useCallback((src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    }, []);

    // Create Razorpay order
    const createRazorpayOrder = useCallback(async (amount) => {
        try {
            const formdata = new FormData();
            formdata.append("user_id", userdata?.id || "");
            formdata.append("amount", amount);

            const response = await axios.post(
                "https://partywitty.com/master/APIs/ClubEvent/createOrder",
                formdata
            );

            return response.data.order_id;
        } catch (error) {
            console.error("Error creating Razorpay order:", error);
            throw new Error("Failed to create payment order");
        }
    }, [userdata]);

    // Verify Razorpay payment
    const verifyRazorpayPayment = useCallback(async (razorpayResponse) => {
        try {
            const formdata = new FormData();
            formdata.append("response", JSON.stringify(razorpayResponse));

            const response = await axios.post(
                "https://partywitty.com/master/APIs/ClubEvent/verifyRzpPayment",
                formdata
            );

            const verificationResponse = response.data;

            if (verificationResponse.status) {
                iziToast.success({
                    title: 'Success',
                    message: verificationResponse.msg,
                    timeout: 5000,
                    position: 'topCenter',
                });
            } else {
                iziToast.error({
                    title: 'Error',
                    message: verificationResponse.msg,
                    timeout: 5000,
                    position: 'topCenter',
                });
            }
        } catch (error) {
            console.error("Error verifying payment:", error);
            iziToast.error({
                title: 'Error',
                message: 'An error occurred while verifying the payment.',
                timeout: 5000,
                position: 'topCenter',
            });
        }
    }, []);

    // Handle Razorpay payment
    const handleRazorpayScreen = useCallback(async (orderId, amount) => {
        try {
            const res = await loadScripts("https://checkout.razorpay.com/v1/checkout.js");
            if (!res) {
                throw new Error("Failed to load Razorpay script");
            }

            const options = {
                key: 'rzp_live_eF5Szxh3Z6WnaS',
                amount: amount * 100,
                currency: "INR",
                name: "PartyWitty",
                description: "Event Ticket Booking",
                order_id: orderId,
                handler: async function (response) {
                    await verifyRazorpayPayment(response);
                    window.location.href = "/success";
                },
                prefill: {
                    name: userdata?.name || "Guest",
                    email: userdata?.email || "guest@partywitty.com",
                },
                theme: {
                    color: "#f4c438",
                },
                modal: {
                    ondismiss: async function () {
                        await verifyRazorpayPayment({ status: "failed" });
                        iziToast.error({
                            title: 'Payment Cancelled',
                            message: 'Payment was cancelled or failed',
                            timeout: 3000,
                            position: 'topCenter',
                        });
                    }
                }
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error("Error opening Razorpay:", error);
            iziToast.error({
                title: 'Payment Error',
                message: 'Error processing payment. Please try again.',
                timeout: 3000,
                position: 'topCenter',
            });
        }
    }, [loadScripts, verifyRazorpayPayment, userdata]);

    // Handle form submission
    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();

        if (!userdata) {
            setShowLoginPopup(true);
            return;
        }

        const selectedTickets = eventdetailsTicket.filter(ticket => ticketCounts[ticket.id] > 0);

        if (selectedTickets.length === 0) {
            iziToast.warning({
                title: 'No Tickets Selected',
                message: 'Please select at least one ticket to proceed',
                timeout: 3000,
                position: 'topCenter',
            });
            return;
        }

        setLoading(true);

        try {
            const qty = selectedTickets.map(ticket => ticketCounts[ticket.id]).join(',');
            const ticket_id = selectedTickets.map(ticket => ticket.id).join(',');

            const formdata = new FormData();
            formdata.append("user_id", userdata.id);
            formdata.append("qty", qty);
            formdata.append("ticket_id", ticket_id);
            formdata.append("platform", "web");

            const response = await axios.post(
                "https://partywitty.com/master/APIs/ClubEvent/placeOrder",
                formdata
            );

            const data = response.data;

            if (data.status) {
                if (data.data.rzp_order_id === "") {
                    // Free booking
                    window.location.href = "/success";
                } else {
                    // Paid booking
                    await handleRazorpayScreen(data.data.rzp_order_id, data.data.net_payable_amount);
                }
            } else {
                throw new Error(data.msg || "Failed to book tickets");
            }
        } catch (error) {
            console.error("Error placing order:", error);
            iziToast.error({
                title: 'Booking Error',
                message: error.message || 'Failed to book tickets. Please try again.',
                timeout: 5000,
                position: 'topCenter',
            });
            setResponseMessage(error.message || 'Failed to book tickets');
        } finally {
            setLoading(false);
        }
    }, [userdata, eventdetailsTicket, ticketCounts, handleRazorpayScreen]);

    // Handle ticket count change
    const handleTicketCountChange = useCallback((id, count) => {
        setTicketCounts((prevCounts) => {
            const newCount = Math.max(count, 0);

            // For free tickets, limit to maximum allowed
            if (isFreeTiket) {
                const currentTotal = Object.values(prevCounts).reduce((sum, c) => sum + c, 0);
                const otherTicketsCount = Object.entries(prevCounts)
                    .filter(([ticketId]) => ticketId !== id.toString())
                    .reduce((sum, [, c]) => sum + c, 0);

                const maxAllowedForThisTicket = maxFreeTickets - otherTicketsCount;
                const limitedCount = Math.min(newCount, maxAllowedForThisTicket);

                if (limitedCount !== newCount && newCount > 0) {
                    iziToast.warning({
                        title: 'Ticket Limit Reached',
                        message: `Maximum ${maxFreeTickets} free tickets allowed per booking`,
                        timeout: 3000,
                        position: 'topCenter',
                    });
                }

                const updatedCounts = { ...prevCounts };
                if (limitedCount === 0) {
                    delete updatedCounts[id];
                } else {
                    updatedCounts[id] = limitedCount;
                }

                return updatedCounts;
            }

            // For paid tickets, no limit
            const updatedCounts = { ...prevCounts };
            if (newCount === 0) {
                delete updatedCounts[id];
            } else {
                updatedCounts[id] = newCount;
            }

            return updatedCounts;
        });
    }, [isFreeTiket]);

    // Handle item click
    const handleItemClickEnhanced = useCallback((ticket) => {
        handleItemClick(ticket);

        // Check if adding one more ticket would exceed the limit for free tickets
        if (isFreeTiket) {
            const currentTotal = Object.values(ticketCounts).reduce((sum, count) => sum + count, 0);
            if (currentTotal >= maxFreeTickets) {
                iziToast.warning({
                    title: 'Ticket Limit Reached',
                    message: `Maximum ${maxFreeTickets} free tickets allowed per booking`,
                    timeout: 3000,
                    position: 'topCenter',
                });
                return;
            }
        }

        setTicketCounts((prevCounts) => ({
            ...prevCounts,
            [ticket.id]: (prevCounts[ticket.id] || 0) + 1,
        }));
    }, [handleItemClick, isFreeTiket, ticketCounts]);

    // Handle checkbox change
    const handleCheckboxChange = useCallback((e) => {
        setUseCarrotBalance(e.target.checked);
    }, []);

    // Fetch event data
    useEffect(() => {
        if (!params.id) return;

        const fetchEventData = async () => {
            try {
                const formData = new FormData();
                formData.append("event_id", params.id);

                // Fetch tickets
                const ticketsResponse = await axios.post(
                    "https://partywitty.com/master/Api/getDataPost/eventTicketType",
                    formData
                );

                if (ticketsResponse.data.status !== "true") {
                    setEventdetailsTicket(ticketsResponse.data.data || []);
                }

                // Fetch event details
                const detailsResponse = await axios.post(
                    "https://partywitty.com/master/Api/getDataPost/eventDetails",
                    formData
                );

                if (detailsResponse.data.data?.[0]) {
                    setEventdetails1(detailsResponse.data.data[0]);
                }
            } catch (error) {
                console.error("Error fetching event data:", error);
                iziToast.error({
                    title: 'Error',
                    message: 'Failed to load event details',
                    timeout: 3000,
                    position: 'topCenter',
                });
            }
        };

        fetchEventData();
    }, [params.id]);

    const openInGoogleMaps = (address) => {
        const encodedAddress = encodeURIComponent(address);
        const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
        window.open(mapsUrl, '_blank');
    };


    return (
        <>
            <div className="event-booking-page">
                <div className="event-booking-container">
                    <div className='event-booking-wrapper'>
                        <div className="event-booking-order-summary">
                            <h2>Order Summary</h2>

                            <div className="event-booking-event-info">
                                <h4>
                                    {eventdetails1.name}
                                    {eventdetails1.categoryName && (
                                        <span> &nbsp; &nbsp;({eventdetails1.categoryName})</span>
                                    )}
                                </h4>
                                <p>{eventdetails1.clubName}</p>
                                <div className='event-booking-event-address-data'>
                                    <p className="event-booking-event-address">
                                        <FaLocationDot />
                                        {eventdetails1?.clubArea} {","} {eventdetails1?.clubCity}
                                    </p>
                                    <p>
                                        <SlCalender />
                                        {eventdetails1?.event_date} | {eventdetails1?.event_time}
                                    </p>
                                </div>

                                {eventdetails1?.clubAddress && (
                                    <div className='event-booking-event-address-button'>
                                        <button onClick={() => openInGoogleMaps(eventdetails1?.clubAddress)} title='Get Direction '><FaDirections /></button>
                                    </div>
                                )}

                                <div className="event-booking-price-row">
                                    {eventdetailsTicket.map((ticket) => (
                                        <div
                                            key={ticket.id}
                                            className="event-booking-ticket-card"
                                            onClick={() => handleItemClickEnhanced(ticket)}
                                        >
                                            <div>
                                                <p className="event_ticket_name">{ticket.name}</p>
                                                <p className="event_ticket_price">
                                                    {parseFloat(ticket.price) === 0
                                                        ? ""
                                                        : `@ ${formatIndianCurrency(ticket.price)}`
                                                    }
                                                </p>
                                                <p
                                                    className="event_ticket_contain"
                                                    dangerouslySetInnerHTML={{ __html: ticket.des }}
                                                />
                                            </div>

                                            <div className="event-booking-counter">
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const currentCount = ticketCounts[ticket.id] || 0;
                                                        if (currentCount > 0) {
                                                            handleTicketCountChange(ticket.id, currentCount - 1);
                                                        }
                                                    }}
                                                    disabled={!ticketCounts[ticket.id]}
                                                >
                                                    -
                                                </button>

                                                <span>{ticketCounts[ticket.id] || 0}</span>

                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const currentCount = ticketCounts[ticket.id] || 0;
                                                        handleTicketCountChange(ticket.id, currentCount + 1);
                                                    }}

                                                    disabled={
                                                        isFreeTiket &&
                                                        calculations.totalQty >= maxFreeTickets
                                                    }
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <span className='event-booking-free-ticket'>* {isFreeTiket && `You can buy up to ${maxFreeTickets} free tickets.`}</span>


                                <div className="event-booking-footer">
                                    <div className='event-booking-footer-bottom'>
                                        <div className="event-booking-total">
                                            {formatIndianCurrency(calculations.finalAmount)}
                                            <br />
                                            <small>
                                                {calculations.totalQty} {calculations.totalQty === 1 ? 'Ticket' : 'Tickets'}
                                            </small>
                                        </div>
                                        <button
                                            onClick={handleSubmit}
                                            disabled={loading || calculations.totalQty === 0}
                                        >
                                            {loading ? 'Processing...' : 'Pay Now'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showLoginPopup && (
                <Loginpopup onClose={() => setShowLoginPopup(false)} />
            )}
        </>
    );
}